<template>
  <span>
    <drr
      class="componente"
      :id="ID"
      :x="parseInt(Left)"
      :y="parseInt(Top)"
      :w="parseInt(Width)"
      :h="parseInt(Height)"
      :angle="parseInt(Angle)"
      :aspectRatio="false"
      :z="0"
      :selectable="Enabled"
      v-on:resizestop="resize"
      v-on:dragstop="drag"
      v-on:rotatestop="rotate"
    >
      <p class="valor-res" v-if="Type == 'TANQUE'">
        {{ Math.floor(ReadPercentage) }} %
      </p>
      <p class="valor-res" v-else-if="Type == 'CONTATO'"></p>
      <br />
      <div class="reservatorio" :id="`${ID}-res`">
        <div class="water" :style="`height: ${ReadPercentage}%;`">
          <!-- <div class="rain front-row"></div>
            <div class="rain back-row"></div> -->
          <div class="bubbleArea">
            <span class="bubble">
              <span class="glow"> </span>
            </span>
            <span class="bubble2">
              <span class="glow"> </span>
            </span>
            <span class="bubble3">
              <span class="glow"> </span>
            </span>
            <span class="bubble4">
              <span class="glow"> </span>
            </span>
          </div>
        </div>
        <!-- <img src="../assets/nivel-agua.png" class="img-responsive nivel-res-img" /> -->
        <p class="nome-res">{{ Nome }}</p>
      </div>
    </drr>
  </span>
</template>

<script>
import drr from "@minogin/vue-drag-resize-rotate";
import datas from "../services/datas";
export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "Reservatorio",
  components: {
    drr
  },
  props: {
    ID: { type: String, default: "0", required: true },
    Max: { type: String, default: "1" },
    Res: { type: String, default: "0" },
    Nome: { type: String, default: "" },
    Top: { type: String, default: "0" },
    Left: { type: String, default: "0" },
    Width: { type: String, default: "100px" },
    Height: { type: String, default: "90px" },
    Angle: { type: String, default: "0" },
    Type: { type: String, default: "" },
    Enabled: { type: Boolean, default: false },
    ReadPercentage: { type: Float64Array, default: 0 }
  },
  data() {
    return {
      vWidth: { type: Number, default: 100 },
      vHeight: { type: Number, default: 100 }
    };
  },
  methods: {
    rotate(pos) {
      let id = this.ID;
      datas
        .salvarAngulo(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | ANGLE: ${pos.angle} | TOP: ${pos.y} | LEFT: ${pos.x} | HEIGTH: ${pos.h} | WIDTH: ${pos.w}`,
            "rotate"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Rotate!\n${error}`);
        });
    },
    resize(pos) {
      this.vWidth = pos.w + "";
      this.vHeight = pos.h + "";
      let el = document.getElementById(`${this.ID}-res`);
      el.style.width = `${this.vWidth}px`;
      el.style.height = `${this.vHeight}px`;
      document.getElementById(`${this.ID}`).style.height = pos.h + "px";
      let id = this.ID;
      datas
        .salvarTamanho(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | HEIGHT: ${pos.h} | WIDTH: ${pos.w} | ANGLE: ${pos.angle}`,
            "resize"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Resize!\n${error}`);
        });
    },
    drag(pos) {
      let id = this.ID;
      datas
        .salvarPosicao(this.ID, pos)
        .then(function(res) {
          console.info(
            `${res} ID: ${id} | TOP: ${pos.y} | LEFT: ${pos.x} | ANGLE: ${pos.angle}`,
            "drag"
          );
        })
        .catch(error => {
          console.warn(`Falha ao atualizar Drag!\n${error}`);
        });
    }
  },
  mounted() {
    let el = document.getElementById(`${this.ID}-res`);
    el.style.width = `${this.Width}px`;
    el.style.height = `${this.Height}px`;
    if (this.Max == null) this.Max = 1;
    if (this.Res == null) this.Res = 0;
    let porcetageReadCalc = (this.Res * 100) / this.Max;
    this.ReadPercentage = porcetageReadCalc > 100 ? 100 : porcetageReadCalc;
  }
};
</script>

<style scoped>
.componente {
  width: 100px;
  height: 200px;
  position: absolute;
  cursor: move;
  z-index: 100;
  /* border: 1px solid black; */
}
.reservatorio {
  position: relative;
  /* top: 50%;
  left: 50%;
  height: 100px;
  transform: translate(-50%, -50%); */
  border: 5px solid #000;
  border-top: 1px solid transparent;
  border-radius: 10px;
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
  background-position: top right;
  background-repeat: repeat-x;
  background-color: white;
  z-index: 0;
  overflow: hidden;
}

.water {
  /* background-image: url("../assets/waves.png"); */
  background-color: #9cc6ff;
  background-position: top right;
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 50%;
  -webkit-transition: all 3s ease-out;
  -moz-transition: all 3s ease-out;
  transition: all 3s ease-out;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 2px;
  z-index: -1;
  overflow: hidden;
}
/* .water {
  height:  10%;
  background-position: top left;
  -webkit-transition: all 5s ease-out;
  -moz-transition: all 5s ease-out;
  transition: all 5s ease-out;
} */

.valor-res {
  position: relative;
  font-size: 23px;
  margin-bottom: -15px;
  text-align: center;
  font-weight: bolder;
  z-index: 1;
}
.nivel-res-img {
  height: 100%;
  padding: 2;
  position: absolute;
  padding-left: 1px;
  padding-bottom: 2px;
  z-index: 1;
}
.nome-res {
  margin: 0;
  padding: 1px;
  padding-top: 35%;
  text-align: center;
  font-weight: bolder;
  font-size: 13px;
  z-index: 1;
}

.bubbleArea {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

/* SASS */
/* BEAKER AND BUBBLES */
@-webkit-keyframes bluePulse {
  from {
    -webkit-box-shadow: 0 0 30px #54a9ed;
  }
  50% {
    -webkit-box-shadow: 0 0 80px #69abdf;
  }
  to {
    -webkit-box-shadow: 0 0 30px #54a9ed;
  }
}

@keyframes bubbleFloat1 {
  from {
    top: 89%;
    transform: scale(0.9);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
  1% {
    bottom: 10%;
    transform: scale(0.3);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
  30% {
    bottom: 20%;
    transform: scale(0.8);
    opacity: 1;
    animation-timing-function: ease-in-out;
  }
  95% {
    bottom: 85%;
    transform: scale(0.3);
    opacity: 1;
    animation-timing-function: ease-in-out;
  }
  99% {
    bottom: 80%;
    transform: scale(1);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
  to {
    top: 0%;
    transform: scale(0);
    opacity: 0;
    animation-timing-function: ease-in-out;
  }
}

.bubbleArea span.glow {
  width: 10%;
  height: 10%;
  position: relative;
  display: block;
  border-radius: 200px;
  animation-name: bluePulse;
  -webkit-animation-name: bluePulse;
  -moz-animation-name: bluePulse;
  -o-animation-name: bluePulse;
  animation-duration: 2s;
  -webkit-animation-duration: 2s;
  -moz-animation-duration: 2s;
  -o-animation-duration: 2s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}

.bubbleArea span.bubble {
  display: block;
  position: relative;
  background: #fff;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(105, 171, 223, 0.2)),
    color-stop(100%, #54a9ed)
  );
  /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#3369abdf", endColorstr="#54a9ed",GradientType=1 );
  /* IE6-9 fallback on horizontal gradient */
  width: 20%;
  height: 20%;
  border-radius: 50%;
  position: relative;
  /* left: random(75) px; */
  /* bottom: 1px; */
  animation-name: bubbleFloat1;
  -webkit-animation-name: bubbleFloat1;
  -moz-animation-name: bubbleFloat1;
  -o-animation-name: bubbleFloat1;
  animation-duration: 5s;
  -webkit-animation-duration: 5s;
  -moz-animation-duration: 5s;
  -o-animation-duration: 5s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}

.bubbleArea span.bubble2 {
  display: block;
  position: relative;
  background: #fff;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(105, 171, 223, 0.2)),
    color-stop(100%, #54a9ed)
  );
  /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#3369abdf", endColorstr="#54a9ed",GradientType=1 );
  /* IE6-9 fallback on horizontal gradient */
  width: 20%;
  height: 20%;
  border-radius: 50%;
  position: absolute;
  left: 75%;
  /* bottom: 1px; */
  animation-name: bubbleFloat1;
  -webkit-animation-name: bubbleFloat1;
  -moz-animation-name: bubbleFloat1;
  -o-animation-name: bubbleFloat1;
  animation-duration: 4.2s;
  -webkit-animation-duration: 4.2s;
  -moz-animation-duration: 4.2s;
  -o-animation-duration: 4.2s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}
.bubbleArea span.bubble3 {
  display: block;
  position: relative;
  background: #fff;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(105, 171, 223, 0.2)),
    color-stop(100%, #54a9ed)
  );
  /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#3369abdf", endColorstr="#54a9ed",GradientType=1 );
  /* IE6-9 fallback on horizontal gradient */
  width: 20%;
  height: 20%;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  /* bottom: 1px; */
  animation-name: bubbleFloat1;
  -webkit-animation-name: bubbleFloat1;
  -moz-animation-name: bubbleFloat1;
  -o-animation-name: bubbleFloat1;
  animation-duration: 4.25s;
  -webkit-animation-duration: 4.25s;
  -moz-animation-duration: 4.25s;
  -o-animation-duration: 4.25s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}
.bubbleArea span.bubble4 {
  display: block;
  position: relative;
  background: #fff;
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* FF3.6+ */
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(105, 171, 223, 0.2)),
    color-stop(100%, #54a9ed)
  );
  /* Chrome,Safari4+ */
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* Opera 12+ */
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* IE10+ */
  background: radial-gradient(
    ellipse at center,
    rgba(105, 171, 223, 0.2) 0%,
    #54a9ed 100%
  );
  /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#3369abdf", endColorstr="#54a9ed",GradientType=1 );
  /* IE6-9 fallback on horizontal gradient */
  width: 20%;
  height: 20%;
  border-radius: 50%;
  position: absolute;
  left: 25%;
  /* bottom: 1px; */
  animation-name: bubbleFloat1;
  -webkit-animation-name: bubbleFloat1;
  -moz-animation-name: bubbleFloat1;
  -o-animation-name: bubbleFloat1;
  animation-duration: 4.5s;
  -webkit-animation-duration: 4.5s;
  -moz-animation-duration: 4.5s;
  -o-animation-duration: 4.5s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
}
</style>
